import styled from 'styled-components'
import { rem } from 'polished'
import LoyaltyBenefitIcon from 'loyalty/components/LoyaltyBenefitIcon'
import { TASTE_OF_GOLD_CAMPAIGN_BENEFIT } from '../constants/tasteOfGoldConstants'
import { getThemeClassName } from 'lib/theme/themeUtils'

const LogoCircle = styled.div<{ $size: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: ${props => rem(props.$size)};
  min-height: ${props => rem(props.$size)};
  width: ${props => rem(props.$size)};
  height: ${props => rem(props.$size)};
  border-radius: 50%;
  background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
  border: 1px solid ${props => props.theme.palette.product.loyalty.gold.normalForeground};
  color: ${props => props.theme.palette.neutral.surface.normalContrast};
`

const SIZES = {
  small: { circle: 32, icon: 16 },
  medium: { circle: 64, icon: 32 },
} as const

const defaultThemeClassName = getThemeClassName({ mobile: 'default' })

interface Props {
  size?: keyof typeof SIZES
}

function TasteOfGoldHeroLogo({ size = 'medium' }: Props) {
  const { circle, icon } = SIZES[size]
  return <LogoCircle $size={circle} className={defaultThemeClassName}>
    <LoyaltyBenefitIcon benefitType={TASTE_OF_GOLD_CAMPAIGN_BENEFIT} size={icon} />
  </LogoCircle>
}

export default TasteOfGoldHeroLogo
